import gql from 'graphql-tag';


export const jobPostservice = gql`
mutation insert_jobpost($postjobObj:jobs_insert_input!) {
  insert_jobs_one(object: $postjobObj) {
    id
  }
}
`;

export const getjobposts = gql`
subscription  getjobposts($limit: Int, $offset: Int) {
  jobs(limit: $limit, offset: $offset) {
    id   
    created_at   
    logo
    company_name
    description
    title    
    education
    experience
    pay_range
    j_role
    j_type
    TypeofEmployment
    location
    address
    roles_and_responsibilities
    description
    short_id
    availability_date
  }
  }
`;

export const getAllJobs = gql`
subscription getalljobs {  
  jobs( order_by: {created_at: desc}){ id   
     title
      j_type
      j_role
      description
      TypeofEmployment
      availability_date
      auto_expiry_date 
      years_of_experience
      dental_practice_id
      dental_supplier_id
      active_status
      location
      logo
      state
      city
      salary
      company_name
      website_url
      pay_range
      education
      video  
      closed_at
      status
      offered_benefits
      country
      endDateToggle
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      timings
      banner_image
      timingtoggle
      created_at
       job_applicants_aggregate{
          aggregate{
            count
         }
       }

  }}`;


export const getMonthlyJobsCountQuery = gql`
  subscription getMonthlyJobsCountQuery($andList: [jobs_bool_exp!]) {
      jobs_aggregate(where: {_and: $andList}) {
        aggregate {
          count
        }
      }
  }`;


export const getApplicantsinfos = gql`subscription getajobswithallprofiles($job_id:uuid) {  
    job_applicants( where: {_and: [{ job_id: {_eq: $job_id}}]}){
    id
    job_id
    attachments
    status
    first_name
    city_name
     dental_professional_id
     dental_professional{
       name
       email
       phone,
       last_name
       first_name
       profile_image
       created_at
     }
       job_applicant_messages{
       id
       message
       message_from
       job_applicant_id
       job_enquiry_id
       }
       job_enquiries{
        id
        enquiry_userid
        enquiry_description
        job_id
        }

   }}`


export const deleteJobFromListMutation = gql`
     mutation DeleteJob($id: uuid!) {
       delete_jobs_by_pk(id: $id) {
         id
       }
     }
   `;

export const updateJobMutation = gql`
  mutation update_jobpost($id: uuid!, $postjobObj: jobs_set_input!) {
    update_jobs_by_pk(pk_columns: { id: $id }, _set: $postjobObj) {
      id
    }
  }
`;

export const updateJobStatusMutation = gql`
  mutation UpdateJobStatus($id: uuid!, $status: String!) {
    update_jobs_by_pk(pk_columns: { id: $id }, _set: { active_status: $status }) {
      id
      active_status
    }
  }
`;

export const updateJobApproveStatusMutation = gql`
  mutation UpdateJobStatus($id: uuid!, $status: String!) {
    update_jobs_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
      status
    }
  }
`;

export const addRoleMutation = gql`mutation insert_jobs_role_list_one($object: jobs_role_list_insert_input!){
  insert_jobs_role_list_one(object:$object){
    id
  }
}`;

export const getAllJobsRoleList = gql`
  query getAllJobsRoleList {
    jobs_role_list(order_by: { created_at: desc }) {
        id
        role_name
        created_at
        updated_at
        created_by
        created_by_user_id
      }
   
  }
`;

export const deleteRolesMutation = gql`
  mutation DeleteNewsfeed($id: uuid!) {
    delete_jobs_role_list_by_pk(id: $id) {
      id
    }
  }
`;

export const editJobsRoleMutation = gql`
  mutation UpdateJobStatus($id: uuid!, $roleName: String!) {
    update_jobs_role_list_by_pk(pk_columns: { id: $id }, _set: { role_name: $roleName }) {
      id
      role_name
    }
  }
`;


export const addEmployeeTypeMutation = gql`mutation insert_job_types_one($object: job_types_insert_input!){
  insert_job_types_one(object:$object){
    id
  }
}`;


export const getAllEmployeeTypeList = gql`
  query getAllEmployeeTypeList {
    job_types(order_by: { created_at: desc }) {
        employee_type_name 
      }
   
  }
`;

export const deleteEmployeeTypeMutation = gql`
  mutation DeleteEmployeeType($id: uuid!) {
    delete_job_types_by_pk(id: $id) {
      id
    }
  }
`;

export const editEmployeeTypeMutation = gql`
  mutation UpdateJobStatus($id: uuid!, $employeeTypeName: String!) {
    update_job_types_by_pk(pk_columns: { id: $id }, _set: { employee_type_name: $employeeTypeName }) {
      id
      employee_type_name
    }
  }
`;

export const updateJobApplicantStatusMutation = gql`
  mutation UpdateJobApplicantStatus($id: uuid!, $status: String!) {
    update_job_applicants_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
      status
    }
  }
`;

export const getAppliedDatas = gql`query getajobswithallprofiles($dental_professional_id:uuid) {  
  job_applicants( where: {_and: [{ dental_professional_id: {_eq: $dental_professional_id}}]}){
  id
  job_id
  attachments
  status
  message
   dental_professional_id
   dental_professional{
     name
     email
     phone,
     last_name
     first_name
     profile_image
     created_at
   }

 }}`

export const getApplicantsJobDatas = gql`
 query getajobswithallprofiles($id: [uuid!], $limit: Int, $offset: Int) {
    jobs(
      where: { id: { _in: $id } }
      limit: $limit
      offset: $offset
    ) {
  id
   title
      j_type
      j_role
      description
      TypeofEmployment
      years_of_experience
      dental_practice_id
      dental_supplier_id
      active_status
      location
      logo
      state
      city
      salary
      company_name
      website_url
      pay_range
      education
      video  
      closed_at
      status
      offered_benefits
      country
      endDateToggle
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      timings
      banner_image
      timingtoggle
      created_at
       job_applicants_aggregate{
          aggregate{
            count
         }
       }
      job_applicants{
        id
        job_id
        status
        dental_professional_id
        message
      }
        job_enquiries{
        id
        enquiry_userid
        enquiry_description
        job_id
        }
 }}`

export const addApplicantMessageMutation = gql`mutation insert_message_one($object:job_applicant_messages_insert_input!){
  insert_job_applicant_messages_one(object:$object){
    id
  }
}`;

export const getApplicantMessagemutation = gql`
  subscription getAllApplicantsmessage($job_id: uuid!) {
    job_applicant_messages(  
        where: { job_applicant: { id: { _eq: $job_id } } }
        order_by: { created_at: asc }) {
        id
        job_applicant_id
        job_enquiry_id  
        message
        message_from
        created_at
        updated_at
        deleted_status
      }
   
  }
`;

export const deleteMessageMutation = gql`
  mutation DeleteapplicantMessage($id: uuid!, $deleted_status: Boolean!) {
    update_job_applicant_messages_by_pk(pk_columns:{id:$id},_set:{deleted_status : $deleted_status}) {
      id
      deleted_status
    }
  }
`;

export const editApplicantMessageMutations = gql`
  mutation UpdateApplicantmessage($id: uuid!, $message: String!) {
    update_job_applicant_messages_by_pk(pk_columns: { id: $id }, _set: { message: $message }) {
      id
      message
    }
  }
`;

export const getEnquiryListMutation = gql`query getEnquiryList($dental_professional_id:uuid) {  
  job_enquiries( where: {_and: [{ enquiry_userid: {_eq: $dental_professional_id}}]}){
  id
  job_id
  created_at
  updated_at
  enquiry_userid
  enquiry_description
  dental_professional{
     name
     email
     phone,
     last_name
     first_name
     profile_image
     created_at
   }

 }}`

export const getAllEnquiry = gql`subscription getEnquiryList($job_id:uuid) {  
  job_enquiries(
    where: { job_id: { _eq: $job_id } }
    distinct_on: enquiry_userid
    order_by: { enquiry_userid: asc, created_at: desc }
  ){
  id
  job_id
  enquiry_userid
  enquiry_description
  dental_professional{
     name
     email
     phone,
     last_name
     first_name
     profile_image
     created_at
   }
     job_profiles {
     profile_image
     full_name
     upload_resume
     profession_type
     location
     country
    }
     job_applicant_messages{
      id
      deleted_status
      attachments
      message
      message_to
      created_at
      updated_at
      job_applicant_id
      job_enquiry_id
      message_from

     }

 }}`

export const getEnquiryMessagemutation = gql`
  subscription getAllEnquirymessage($job_id: uuid!) {
    job_applicant_messages(  
        where: { job_enquiry_id:  { _eq: $job_id  } }
        order_by: { created_at: asc }) {
        id
        job_applicant_id 
        job_enquiry_id 
        message
        message_from
        created_at
        updated_at
        deleted_status
      }
   
  }
`;

export const getAllJobsfiltered = gql`
    query getalljobsFilter($where: jobs_bool_exp!) {
    jobs(where: $where, order_by: { created_at: desc }) {
      id
      title
      j_type
      j_role
      description
      TypeofEmployment
      years_of_experience
      availability_date
      dental_practice_id
      dental_supplier_id
      active_status
      location
      logo
      state
      city
      salary
      company_name
      website_url
      pay_range
      education
      video
      closed_at
      status
      offered_benefits
      country
      endDateToggle
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      timings
      banner_image
      timingtoggle
      created_at
      job_applicants_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;


export const talentPostservice = gql`
mutation insert_jobpost($jobHiringsDetails:jobhirings_insert_input!) {
  insert_jobhirings_one(object: $jobHiringsDetails) {
    id
  }
}
`;
export const updateHiringStatusMutation = gql`
  mutation updateHiringStatus($id: uuid!, $status: String!) {
    update_jobhirings_by_pk(pk_columns: { id: $id }, _set: { hiring_status: $status }) {
      id
      hiring_status
    }
  }
`;




export const updateTalentHireApproveStatusMutation = gql`
  mutation UpdateTalentStatus($id: uuid!, $status: String!) {
    update_jobhirings_by_pk(pk_columns: { id: $id }, _set: { hiring_status: $status }) {
      id
      hiring_status
    }
  }
`;

export const getAllTalentsHire = gql`
  subscription getallTalent {
    jobhirings(order_by: { created_at: desc }) {
      id
      dental_professional_id
      dental_supplier_id
      hiring_status
      updated_at
      created_at
      job_profiles_id
      dental_practice_id

    talents_message{
        id 
        message
        message_from
        created_at
        updated_at
        talent_message_id_to
        enquiry_message_id_to
        deleted_status
    }

        talent_enquiries{
            id
            talent_id
            enquiry_description
            enquiry_from
            created_at
            updated_at

        }

      dental_supplier {
        id
        name
        email
        phone
        profile_image
        logo
      }

      dental_practice{
        id
        name
        email
        phone
        profile_image
        logo
      }

      job_profiles {
        id
        created_at
        updated_at
        skills
        jobexperiences
        upload_resume
        job_location
        job_designation
        current_company
        current_ctc
        dental_professional_id
        post_anonymously
        admin_status
        profile_image
        profession_type
        work_type
        state
        city
        full_name
        languages_spoken
        availabilityOption
        availabilityDate
        Year_of_experiance
        availabilityDay

            dental_professional{
                id
                profile_image
                  directories{
                    id
                    dental_professional_id
                    logo
                    profile_image
                    }
            }

            talent_enquiries{
            id
            talent_id
            enquiry_description
            enquiry_from
            created_at
            updated_at

        }
            jobhirings{
            id
            created_at
            dental_supplier_id
            dental_professional_id
            hiring_status
            job_profiles_id
            dental_practice_id

            }

      }
        directories{
        dental_supplier_id
        logo
        }
    }
  }
`;
export const getAllTalentsRequest = gql`
  query getAllTalentsRequest(
    $where: jobhirings_bool_exp
    $limit: Int
    $offset: Int
  ) {
    jobhirings(
      where: $where
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      dental_professional_id
      dental_supplier_id
      hiring_status
      updated_at
      created_at
      job_profiles_id
      dental_practice_id

      dental_supplier {
        id
        logo
        name
        directories {
          id
          email
          phone
        }
      }

      dental_practice {
        id
        logo
        name
        directories {
          id
          email
          phone
        }
      }

      talent_enquiries_find_practice {
        id
      }
      talent_enquiries_find_supplier {
        id
      }
    }
  }
`;

export const getRequestCountOnlyQuery = gql`
  subscription getRequestCount($dental_professional_id: uuid!) {
    jobhirings_aggregate(
      where: {
        dental_professional_id: { _eq: $dental_professional_id }
         hiring_status: { _nin: ["REJECT", "CANCELLED"] }
      }
    ) {
      aggregate {
       count
      }
    }
  }
`;

export const addTalentMessageMutation = gql`mutation insert_message_one($object:talents_message_insert_input!){
  insert_talents_message_one(object:$object){
    id
  }
}`;

export const getTalentMessagemutation = gql`
  subscription getAllTalentsmessage($job_id: uuid!) {
    talents_message(  
        where: { talent_message_id_to:  { _eq: $job_id } } 
        order_by: { created_at: asc }) {
        id 
        message
        message_from
        created_at
        updated_at
        talent_message_id_to
        enquiry_message_id_to
        deleted_status
      }
   
  }
`;

export const getTalentEnquiryMessagemutation = gql`
  subscription getAllTalentsEnquirymessage($job_id: uuid!) {
    talents_message(  
        where: { enquiry_message_id_to:  { _eq: $job_id } } 
        order_by: { created_at: asc }) {
        id 
        message
        message_from
        created_at
        updated_at
        talent_message_id_to
        enquiry_message_id_to
        deleted_status
      }
   
  }
`;


export const deleteTalentMessageMutation = gql`
  mutation DeleteTalentMessage($id: uuid!, $deleted_status: Boolean!) {
    update_talents_message_by_pk(pk_columns:{id:$id},_set:{deleted_status : $deleted_status}) {
      id
      deleted_status
    }
  }
`;

export const editTalentMessageMutation = gql`
  mutation UpdateTalentmessage($id: uuid!, $message: String!, $updated_at : timestamptz!){
    update_talents_message_by_pk(pk_columns: {id: $id}, _set:{message: $message, updated_at : $updated_at  }){
       id
       message
       updated_at
    } 
  }
`;


export const getTalentEnquiryListMutation = gql`subscription getTalentEnquiryList($login_id:uuid) {  
  talent_enquiries( where: {_and: [{ enquiry_from: {_eq: $login_id}}]}){
  id
  created_at
  talent_id
  updated_at
  enquiry_description
  enquiry_from

  job_profiles {
        id
        created_at
        updated_at
        skills
        jobexperiences
        upload_resume
        job_location
        job_designation
        current_company
        current_ctc
        dental_professional_id
        post_anonymously
        admin_status
        profile_image
        profession_type
        work_type
        state
        city
        full_name
        languages_spoken
        availabilityOption
        availabilityDate
        Year_of_experiance
        availabilityDay

           dental_professional{
              id
              profile_image
              directories{
                id
                dental_professional_id
                logo
                profile_image
                  }
            }

        jobhirings{
            id
            created_at
            dental_supplier_id
            dental_professional_id
            hiring_status
            job_profiles_id
            }

            talent_enquiries{
              id
              talent_id
              enquiry_description
              enquiry_from
              created_at
              updated_at
            }

      }
 
 }}`

export const getAllRequestMutation = gql`
subscription getEnquiryList($job_id:uuid!) {  
  jobhirings
    ( where: { job_profiles_id: {_eq: $job_id}}
     ){

        id
      dental_professional_id
      dental_supplier_id
      hiring_status
      updated_at
      created_at
      job_profiles_id
      dental_supplier_id

    talents_message{
        id 
        message
        message_from
        created_at
        updated_at
        talent_message_id_to
        enquiry_message_id_to
        deleted_status
    }

        talent_enquiries{
            id
            talent_id
            enquiry_description
            enquiry_from
            created_at
            updated_at

        }


      dental_supplier {
        id
        name
        email
        phone
        profile_image
        logo
      }
      job_profiles {
        id
        created_at
        updated_at
        skills
        jobexperiences
        upload_resume
        job_location
        job_designation
        current_company
        current_ctc
        dental_professional_id
        post_anonymously
        admin_status
        profile_image
        profession_type
        work_type
        state
        city
        full_name
        languages_spoken
        availabilityOption
        availabilityDate
        Year_of_experiance
        availabilityDay

            talent_enquiries{
            id
            talent_id
            enquiry_description
            enquiry_from
            created_at
            updated_at

        }
            jobhirings{
            id
            created_at
            dental_supplier_id
            dental_professional_id
            hiring_status
            job_profiles_id
            }

      }
        directories{
        id
        dental_supplier_id
        logo
        }

}}`

export const getAllTalentEnquiryMutation = gql`
  query getEnquiryList($job_id: uuid!, $limit: Int!, $offset: Int!) {
    talent_enquiries(
      where: { talent_id: { _eq: $job_id } }
      limit: $limit
      offset: $offset
    ) {

  id
  talent_id
  enquiry_description
  enquiry_from
  created_at
  updated_at

      talents_message{
      id
      created_at
      updated_at
      message_from
      message
      talent_message_id_to
      enquiry_message_id_to
      deleted_status
      }


     dental_suppliers {
        id
        name
        email
        phone
        profile_image
        logo
     
      }
        
     directories{
        id
        dental_supplier_id
        profile_image
        logo
        }

    dental_practices{
        id
        name
        email
        phone
        profile_image
        logo

        directories{
        id
        }
       }
 }}`


export const getAllTalentEnquiryPaginationQuery = gql`
  query getPaginatedEnquiries($job_id: uuid!, $limit: Int, $offset: Int) {
    talent_enquiries(
      where: { talent_id: { _eq: $job_id } }
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      talent_id
      enquiry_description
      enquiry_from
      created_at
      updated_at

      talents_message {
        id
        created_at
        updated_at
        message_from
        message
        talent_message_id_to
        enquiry_message_id_to
        deleted_status
      }

      dental_suppliers {
        id
        name
        email
        phone
        profile_image
        logo
      }

      directories {
        id
        dental_supplier_id
        profile_image
        logo
      }

      dental_practices {
        id
        name
        email
        phone
        profile_image
        logo
      }
    }
  }
`;

export const getEnquiryCountOnlyQuery = gql`
  query getEnquiryCountOnly($talent_id: uuid!) {
    talent_enquiries_aggregate(
      where: {  talent_id: { _eq: $talent_id }  }
        order_by: { enquiry_from: asc, created_at: desc }
      distinct_on: enquiry_from
    ) {
      aggregate {
        count
      }
    }
  }
`;



export const getAllTAlentEnquiryListMutation = gql`subscription getEnquiryList($dental_professional_id:uuid) {  
  talent_enquiries( where: {_and: [{ enquiry_from: {_eq: $dental_professional_id}}]}){
  id
  talent_id
  enquiry_description
  enquiry_from
  created_at
  updated_at
     dental_suppliers {
        id
        name
        email
        phone
        profile_image
        logo
      }

 }}`


//  

export const getJobListMutation = gql`
   query getJobList($limit: Int, $offset: Int, $where: jobs_bool_exp,  $order_by: [jobs_order_by!]) {
     jobs(
       where: $where
       order_by: $order_by
       limit: $limit
       offset: $offset
     ) {
      id
      title
      j_type
      j_role
      dental_supplier_id
      dental_practice_id
      description
      TypeofEmployment
      availability_date
      auto_expiry_date
      years_of_experience
      active_status
      location
      logo
      state
      city
      company_name
      status
      country
      banner_image
      created_at
}
   }
 `;

// show single jobs fully by id
export const getJobListMutationByid = gql`
    query getJobListMutationbyid($id: uuid!) {
    jobs(where: { id: { _eq: $id } }) {
      id
      title
      j_role
      description
      TypeofEmployment
      years_of_experience
      company_name
      location
      logo
      dental_practice_id
      dental_supplier_id
      state
      city
      website_url
      pay_range
      education
      country
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      banner_image
      created_at
}
   }
 `;

// get related 
export const getRelatedJobs = gql`
query GetRelatedJobs($jRole: String, $limit: Int!, $offset: Int!, $excludeId: uuid!) {
        jobs(
          where: { j_role: { _eq: $jRole }, id: { _neq: $excludeId },
          status: { _eq: "APPROVE" }, active_status: { _eq: "ACTIVE" } }
          limit: $limit
          offset: $offset
          order_by: [{ created_at: desc }, { id: asc }]
        ) {
      
     id
      title
      j_role
      description
      TypeofEmployment
      years_of_experience
      location
      logo
      state
      company_name
      city
      website_url
      pay_range
      dental_practice_id
      dental_supplier_id
      education
      country
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      banner_image
      created_at

  }}`;

export const getFilteredJobs = gql`
  query getFilteredJobs($limit: Int, $offset: Int, $where: jobs_bool_exp) {
    jobs(
      limit: $limit
      offset: $offset
      order_by: { updated_at: desc }
      where: $where
    ) {
      id
      title
      description
      TypeofEmployment
      dental_practice_id
      dental_supplier_id
      active_status
      logo
      company_name
      j_role
      status
      created_at
      location
      job_applicants_aggregate {
        aggregate {
          count
        }
      }
      job_enquiries_aggregate(distinct_on: enquiry_userid) {
        aggregate {
          count
        }
      }
    }
  }
`;


export const getAdminJobsTabCounts = gql`
  query getAdminJobsTabCounts($where: jobs_bool_exp) {
    all: jobs_aggregate(where: $where) {
      aggregate { count }
    }
    pending: jobs_aggregate(where: { status: { _eq: "PENDING" } }) {
      aggregate { count }
    }
    approved: jobs_aggregate(where: { status: { _eq: "APPROVE" } }) {
      aggregate { count }
    }
    rejected: jobs_aggregate(where: { status: { _eq: "REJECT" } }) {
      aggregate { count }
    }
      expired: jobs_aggregate(where: { status: { _eq: "EXPIRED" } }) {
      aggregate { count }
    }
  }
`;

export const getUserJobsTabCounts = gql`
  query getUserJobsTabCounts($where: jobs_bool_exp!) {
  all: jobs_aggregate(where: $where) {
    aggregate { count }
  }
  pending: jobs_aggregate(where: { _and: [$where, { status: { _eq: "PENDING" } }] }) {
    aggregate { count }
  }
  active: jobs_aggregate(
    where: {
      _and: [
        $where,
        { status: { _eq: "APPROVE" } },
        { active_status: { _eq: "ACTIVE" } }
      ]
    }
  ) {
    aggregate { count }
  }
  inactive: jobs_aggregate(
    where: {
      _and: [
        $where,
        { status: { _eq: "APPROVE" } },
        { active_status: { _eq: "INACTIVE" } }
      ]
    }
  ) {
    aggregate { count }
  }
  expired: jobs_aggregate(where: { _and: [$where, { status: { _eq: "EXPIRED" } }] }) {
    aggregate { count }
  }
  rejected: jobs_aggregate(where: { _and: [$where, { status: { _eq: "REJECT" } }] }) {
    aggregate { count }
  }
  draft: jobs_aggregate(where: { _and: [$where, { status: { _eq: "DRAFT" } }] }) {
    aggregate { count }
  }
}
`;

// export const getUserJobsTabCounts = gql`
//   subscription getUserJobsTabCounts($where: jobs_bool_exp!) {
//     jobs_aggregate(where: $where) {
//       nodes {
//         status
//         active_status
//       }
//     }
//   }
// `;



// new talent list :

export const getFilteredTalentList = gql`
  query getFiltredTalentList(
    $where: job_profiles_bool_exp
    $limit: Int
    $offset: Int
  ) {
    job_profiles(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { updated_at: desc }
    ) {
      id
      admin_status
      active_status
      current_company

      created_at
      updated_at
      skills
      jobexperiences
      job_designation
      dental_professional_id
      profile_image
      full_name
      work_type
      profession_type
      location
      country
      city
      state
      fromDate
      dental_professional {
        id
      }
      jobhirings {
        id
      }
    }
  }
`;



// talent list course count admin


//  export const getTalentAdminCountByStatus = gql`

//   subscription getTalentAdminCountByStatus($where: job_profiles_bool_exp!) {
//     job_profiles_aggregate(where: $where) {
//       nodes {
//         admin_status
//       }
//     }
//   }

// `;

export const getTalentAdminCountByStatus = gql`
  query getTalentAdminCountByStatus(
  $whereAll: job_profiles_bool_exp = {}
  $where: job_profiles_bool_exp = {}
) {
  all: job_profiles_aggregate(where: $whereAll) {
    aggregate {
      count
    }
  }
  
  pending: job_profiles_aggregate(
    where: { _and: [$where, { admin_status: { _eq: "PENDING" } }] }
  ) {
    aggregate {
      count
    }
  }

  
  approve: job_profiles_aggregate(
    where: { _and: [$where, { admin_status: { _eq: "APPROVE" } }] }
  ) {
    aggregate {
      count
    }
  }
  rejected: job_profiles_aggregate(
    where: { _and: [$where, { admin_status: { _eq: "REJECT" } }] }
  ) {
    aggregate {
      count
    }
  }
}

`;



// approve admin talent

export const updateTalentStatusMutation = gql`
  mutation UpdateTalentStatus($id: uuid!, $admin_status: String!) {
    update_job_profiles_by_pk(pk_columns: { id: $id }, _set: { admin_status: $admin_status }) {
      id
      admin_status
    }
  }
`;



// filter talent 
export const getUniqueTalentFilterOptions = gql`
  query GetUniqueTalentFilterOptions($where: job_profiles_bool_exp = {}) {
    admin_status: job_profiles(
      where: $where
      distinct_on: [admin_status]
    ) {
      admin_status
    }

    profession_types: job_profiles(
      where: $where
      distinct_on: [profession_type]
    ) {
      profession_type
    }

    
  }
`;




// new talent Hiring List Filter

export const getHiringTalentList = gql`
  query getHiringTalentList(
    $where: jobhirings_bool_exp
    $limit: Int
    $offset: Int
  ) {
    jobhirings(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { updated_at: desc }
    ) {
      id
      dental_professional_id
      dental_supplier_id
      hiring_status
      updated_at
      created_at
      job_profiles_id
      dental_practice_id

      dental_supplier {
        id
        name
        profile_image
        logo
      }

      dental_practice {
        id
        name
        profile_image
        logo
      }

      job_profiles {
        id
        full_name
        profession_type
        state
        profile_image
        work_type
        dental_professional_id

        dental_professional {
          profile_image
        }
      }

      talent_enquiries_find_practice {
        id
      }

      talent_enquiries_find_supplier {
        id
      }

      directories {
        dental_supplier_id
        logo
      }
        
    }
  }
`;

// filter enquiry 

export const getFilterEnquiriesList = gql`
  query getTalentEnquiriesList(
    $where: talent_enquiries_bool_exp
    $limit: Int
    $offset: Int
  ) {
    talent_enquiries(
      where: $where
      limit: $limit
      offset: $offset
      order_by: [{ talent_id: asc }, { updated_at: desc }]
      distinct_on: talent_id
    ) {
      id
      created_at
      talent_id
      updated_at
      enquiry_description
      enquiry_from

      job_profiles {
        id
        created_at
        updated_at
        job_location
        job_designation
        dental_professional_id
        admin_status
        profile_image
        profession_type
        work_type
        state
        city
        full_name

        dental_professional {
          id
          profile_image
          directories {
            id
            dental_professional_id
            logo
            profile_image
          }
        }

        jobhirings {
          id
          created_at
          dental_supplier_id
          dental_professional_id
          hiring_status
          job_profiles_id
        }

        talent_enquiries {
          id
          talent_id
          enquiry_description
          enquiry_from
          created_at
          updated_at
        }
      }
    }
  }
`;



// Hiring user talent count

export const getHiringTalentCountByStatus = gql`
  query getTalentHiringCountByStatus(
  $where: jobhirings_bool_exp = {}
) {
  all: jobhirings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  
  pending: jobhirings_aggregate(
    where: { _and: [$where, { hiring_status: { _eq: "PENDING" } }] }
  ) {
    aggregate {
      count
    }
  }

  
  approve: jobhirings_aggregate(
    where: { _and: [$where, { hiring_status: { _eq: "APPROVE" } }] }
  ) {
    aggregate {
      count
    }
  }

  rejected: jobhirings_aggregate(
    where: { _and: [$where, { hiring_status: { _eq: "REJECT" } }] }
  ) {
    aggregate {
      count
    }
}

  cancelled: jobhirings_aggregate(
    where: { _and: [$where, { hiring_status: { _eq: "CANCELLED" } }] }
  ) {
    aggregate {
      count
    }
  }
}

`;


//user hiring 

// filter talent 
export const getHiringFilterOptions = gql`
  query GetUniqueTalentFilterOptions(
    $whereProfiles: job_profiles_bool_exp = {}
  ) {
    hiring_status: jobhirings(distinct_on: hiring_status) {
      hiring_status
    }

    profession_types: job_profiles(
      where: $whereProfiles
      distinct_on: profession_type
    ) {
      profession_type
    }
  }
`;


export const getJobCompanyName = gql`
 query getCompanyName($limit: Int!, $offset: Int!, $search: String) {
  jobs(
    distinct_on: company_name
    order_by: { company_name: asc }
    where: { 
      company_name: { _is_null: false }
      _and: [
        { company_name: { _ilike: $search } }
      ]
    }
    limit: $limit
    offset: $offset
  ) {
    company_name
  }
}
`;

export const getJobRoleName = gql`
query getRoleName($limit: Int!, $offset: Int!, $search: String) {
  jobs(
    distinct_on: [j_role]
    order_by: { j_role: asc }   
    where: { 
      j_role: { _is_null: false, _ilike: $search }
    }
    limit: $limit
    offset: $offset
  ) {
    j_role
  }
}

`;
export const getFilterStatus = gql`
query getStatusFilter($limit: Int!, $offset: Int!, $search: String) {
  jobs(
    distinct_on: [status]
    order_by: { status: asc }   
    where: { 
      status: { _is_null: false, _ilike: $search,  _nin: ["DRAFT", "EXPIRED"] }
    }
    limit: $limit
    offset: $offset
  ) {
    status
  }
}

`;

export const getEmpTypeName = gql`
query getEmpTypeName($limit: Int!, $offset: Int!) {
  jobs(
    where: { TypeofEmployment: { _is_null: false } }
    limit: $limit
    offset: $offset
  ) {
    TypeofEmployment
  }
}
`;

// new query implemeted:

export const getMyJobData = gql`
  query getMyJobData($jobId: uuid!) {
    jobs_by_pk(id: $jobId) {
      id
      title
      description
      TypeofEmployment
      dental_practice_id
      dental_supplier_id
      active_status
      logo
      company_name
      j_role
      status
      created_at
      location
    }
  }
`;

export const getFilteredApplicants = gql`
  query getFilteredApplicants(
    $limit: Int,
    $offset: Int,
    $where: job_applicants_bool_exp
  ) {
    job_applicants(
      limit: $limit, 
      offset: $offset, 
      order_by: {updated_at: desc}, 
      where: $where
    ) {
      id
      job_id
      attachments
      status
      first_name
      city_name
      dental_professional_id
      dental_professional {
        name
        email
        phone
        last_name
        first_name
        profile_image
        created_at
      }
     
        job_enquiries_find{
        id
        }
    }
  }
`;


export const getJobFilteredEnquiry = gql`
  query getJobFilteredEnquiry(
    $limit: Int
    $offset: Int
    $where: job_enquiries_bool_exp
  ) {
    job_enquiries(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { enquiry_userid: asc, created_at: desc }
      distinct_on: enquiry_userid
    ) {
      id
      job_id
      enquiry_userid
      enquiry_description
      dental_professional {
        name
        email
        phone
        last_name
        first_name
        profile_image
        created_at
      }
      job_profiles {
        profile_image
        full_name
        upload_resume
        profession_type
        location
        country
      }
      job_applicants_find {
        id
      }
    }
  }
`;


// new Applicant message :

export const getApplicantsMessage = gql`
  subscription getAllApplicantsmessage($where: job_applicant_messages_bool_exp!) {
    job_applicant_messages(
      where: $where
      order_by: { created_at: asc }
    ) {
      id
      job_applicant_id
      job_enquiry_id
      message
      message_from
      created_at
      updated_at
      deleted_status
    }
  }
`;

// test limit
export const TestgetApplicantsMessage = gql`
  subscription getAllApplicantsmessage(
  $where: job_applicant_messages_bool_exp!
   $limit: Int
  $offset: Int
  ) {
    job_applicant_messages(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { created_at: asc }
    ) {
      id
      job_applicant_id
      job_enquiry_id
      message
      message_from
      created_at
      updated_at
      deleted_status
    }
  }
`;

// new applicant enquiry
export const getApplicantsEnquiry = gql`
query getApplicantsEnquiry($where: job_enquiries_bool_exp!) {  
  job_enquiries( 
  where : $where
  order_by: { created_at: asc }
  ){
  id
  job_id
  created_at
  updated_at
  enquiry_userid
  enquiry_description
 }}`

//  new applicanttab count 

export const getApplicantTabcount = gql`
  query getApplicantsTabCounts($where: job_applicants_bool_exp!) {
    all: job_applicants_aggregate(where: $where) {
      aggregate { count }
    }
    applied: job_applicants_aggregate(where:{ _and: [$where, { status: { _eq: "APPLIED" } } ] }) {
      aggregate { count }
    }
    shortlisted: job_applicants_aggregate(where: { _and: [$where, { status: { _eq: "SHORTLISTED" } } ] }) {
      aggregate { count }
    }
    interviews: job_applicants_aggregate(where:{_and: [$where,  { status: { _eq: "INTERVIEWS" }} ] }) {
      aggregate { count }
    }
      accepted: job_applicants_aggregate(where:{_and: [$where, { status: { _eq: "ACCEPTED" } } ] }) {
      aggregate { count }
    }
      declined: job_applicants_aggregate(where:{ _and: [$where,  { status: { _eq: "DECLINED" } }]}) {
      aggregate { count }
    }
  }
`;


export const getMyappliedJobData = gql`
  query getmyAppliedJobData(
    $limit: Int
    $offset: Int
    $where: job_applicants_bool_exp
  ) {
    job_applicants(
      limit: $limit
      offset: $offset
      order_by: { updated_at: desc }
      where: $where
    ) {
      id
      created_at
      job_id
      status
      dental_professional_id
      dental_professional {
        profile_image
      }
      job {
        id
        title
        logo
        company_name
        j_role
        TypeofEmployment
      }

      job_enquiries_find {
        id
      }
    }
  }
`;

export const getMyEnquiryJobData = gql`
  query getMyEnquiryJobData(
    $limit: Int
    $offset: Int
    $where: job_enquiries_bool_exp
  ) {
    job_enquiries(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { job_id: asc, created_at: desc }
      distinct_on: job_id
    ) {
      id
      job_id
      enquiry_userid
      dental_professional {
        profile_image
      }
      jobs {
        id
        title
        logo
        company_name
        j_role
        TypeofEmployment
      }

      job_applicants_find {
        id
      }
    }
  }
`;

export const getMyEnquiryTalentData = gql`
  query getMyEnquiryJobData(
    $limit: Int
    $offset: Int
    $where: talent_enquiries_bool_exp
  ) {
    talent_enquiries(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { talent_id: asc, created_at: desc }
      distinct_on: talent_id
    ) {
      id
      created_at
      talent_id
      enquiry_from
      dental_practices {
        logo
      }
      job_profiles {
        id
        full_name
        profession_type
        state
        profile_image
        work_type
        dental_professional_id

        dental_professional {
          profile_image
        }
      }

      jobhirings_find_practice {
        id
      }
      jobhirings_find_supplier {
        id
      }
    }
  }
`;

// new Applicant message :

export const getTalentsMessage = gql`
  subscription getAllTalentsmessage($where: talents_message_bool_exp!) {
    talents_message(
      where: $where
      order_by: { created_at: asc }
    ) {
      id
      talent_message_id_to
      enquiry_message_id_to
      message
      message_from
      created_at
      updated_at
      deleted_status
      talent_id
    }
  }
`;

// new applicant enquiry
export const getTalentsEnquiry = gql`
query getTalentsEnquiry($where: talent_enquiries_bool_exp!) {  
  talent_enquiries( 
  where : $where
  order_by: { created_at: asc }
  ){
  id
  talent_id
  created_at
  updated_at
  enquiry_from
  enquiry_description
 }}`


//  talen enquiry
export const getAllEnquiryTalentData = gql`
  query getMyEnquiryJobData(
    $limit: Int
    $offset: Int
    $where: talent_enquiries_bool_exp
  ) {
    talent_enquiries(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { enquiry_from: asc, created_at: desc }
      distinct_on: enquiry_from
    ) {
      id
      created_at
      talent_id
      enquiry_from
      dental_practices {
        id
        name
        logo
        directories{
        id
        email
        phone
        }
      }
      dental_suppliers {
        id
        name
        logo
        directories{
        id
        email
        phone
        }
        
      }

      jobhirings_find_practice {
        id
      }
      jobhirings_find_supplier {
        id
      }
    }
  }
`;


export const GetEditJobID = gql`
    query GetEditJobIDData($Jobid: uuid!) {
    jobs(where: { id: { _eq: $Jobid } }) {
      id   
     title
      j_type
      j_role
      description
      TypeofEmployment
      availability_date
      auto_expiry_date 
      years_of_experience
      dental_practice_id
      dental_supplier_id
      active_status
      location
      logo
      state
      city
      salary
      company_name
      website_url
      pay_range
      education
      video  
      closed_at
      status
      offered_benefits
      country
      endDateToggle
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      timings
      banner_image
      timingtoggle
      created_at
       job_applicants_aggregate{
          aggregate{
            count
         }
       }
}
   }
 `;


